import { useTranslation } from "react-i18next";
import { skills } from "../data/dados";

export default function Skills() {
  const { t } = useTranslation('translation', { useSuspense: false });
  return (
    <section className="section">
      <h2>{t('title.skills')}</h2>
      <div className="badge-container">{skills.map(skill => <span className="badge" key={skill}>{skill}</span>)}</div>
    </section>
  );
}
